import type { PageHelp } from '../network-help.data';

export const L10N_fa_g2: Record<string, PageHelp> = {
  'agency-onboarding': {
    title: 'راه‌اندازی آژانس',
    tag: 'راهنمای گام‌به‌گام',
    tagline: 'ورود یک کسب‌وکار مسافرتی جدید به شبکه، به‌صورت منطبق با مقررات.',
    business: {
      lead: 'راه‌اندازی، درِ ورودی کنترل‌شده به شبکه است. پیش از آنکه یک آژانس جدید بتواند پول جابه‌جا کند یا بلیت صادر کند، پلتفرم باید بداند آن‌ها چه کسانی هستند، آن‌ها را احراز هویت کند و بر سر شرایط تجاری توافق کند — این همان جایی است که آن رابطه شکل می‌گیرد.',
      points: [
        { title: 'انطباق پیش از تجارت', desc: 'بررسی‌های هویتی و مالی (KYC) از همان ابتدا انجام می‌شوند، چون پلتفرم به یک طرف حساب جدید اعتبار و تسویه اعطا می‌کند.' },
        { title: 'شرایط، رابطه را تعیین می‌کنند', desc: 'سطح، پروفایل مارک‌آپ و دسترسی به محصولات اینجا توافق می‌شوند — این‌ها تعیین می‌کنند آژانس از روز نخست چگونه تجارت کند.' },
        { title: 'زمان کوتاه تا نخستین فروش', desc: 'یک راه‌اندازی تمیز، یک شریک درآمدزا را در بازهٔ زمانی تعهدشدهٔ راه‌اندازی (SLA) عملیاتی می‌کند.' },
      ],
    },
    software: {
      lead: 'یک فرم چندمرحله‌ای هدایت‌شده که رکورد آژانس را می‌سازد و آن را برای تأیید مسیردهی می‌کند.',
      points: [
        { title: 'گام‌به‌گام در رکورد', desc: 'شرکت ← افراد تماس ← مدارک KYC ← تنظیمات مالی ← محصولات و دسترسی ← سطح و مارک‌آپ ← بازبینی.' },
        { title: 'ارسال به صف', desc: 'تکمیل راهنمای گام‌به‌گام، درخواست را به‌جای عملیاتی‌شدن فوری، در صف بررسی KYC ثبت می‌کند.' },
        { title: 'همه‌چیز در یک‌جا', desc: 'افراد تماس، مدارک و شرایط تجاری با هم ثبت می‌شوند تا بررسی‌کنندگان تصویر کاملی داشته باشند.' },
      ],
    },
    related: ['agency-kyc', 'contract-templates', 'agencies'],
  },

  'agency-kyc': {
    title: 'صف بررسی KYC',
    tag: 'انطباق',
    tagline: 'دروازه‌ای که هر آژانس جدید پیش از توانایی تجارت از آن عبور می‌کند.',
    business: {
      lead: 'KYC — مشتری خود را بشناس — تعهد به احراز هویت یک کسب‌وکار پیش از اجازهٔ جابه‌جایی پول در پلتفرم است. این صف، نقطهٔ بازرسی‌ای است که شبکه را از تقلب و ریسک مطالبات معوق محافظت می‌کند.',
      points: [
        { title: 'یک الزام، نه یک تشریفات', desc: 'پلتفرم باید پیش از اعطای کیف پول یا اعتبار، طرف‌های حساب را احراز هویت کند.' },
        { title: 'ریسک، قابل مشاهده', desc: 'هر درخواست یک نشانهٔ ریسک به همراه دارد تا بررسی‌کنندگان زمان خود را جایی صرف کنند که ریسک بالاترین است.' },
        { title: 'SLA یک تعهد است', desc: 'رسیدگی سریع به درخواست‌ها راه‌اندازی را سریع نگه می‌دارد بدون آنکه بررسی نادیده گرفته شود.' },
      ],
    },
    software: {
      lead: 'یک صف تفکیک برای درخواست‌های در انتظار، که هر کدام یک خط‌ لولهٔ مدارک برای تأیید یا رد دارد.',
      points: [
        { title: 'کار روی صف', desc: 'فهرست درخواست‌ها همراه با مرحله‌شان؛ یکی را باز کنید تا مدارک ارسال‌شده‌اش را بررسی کنید.' },
        { title: 'دنبال‌کردن خط‌ لوله', desc: 'یک نمای پیشرفت مرحله‌ای نشان می‌دهد هر درخواست کجاست و پیش از تصمیم‌گیری چه چیزی باقی مانده است.' },
        { title: 'تصمیم‌گیری', desc: 'تأیید کنید تا آژانس وارد تجارت زنده شود (که به‌صورت خودکار توافق‌نامهٔ اصلی‌اش را تولید می‌کند)، یا با ذکر دلیل رد کنید.' },
      ],
    },
    related: ['agency-onboarding', 'contract-templates', 'agencies'],
  },

  'agency-profile': {
    title: 'پروفایل آژانس',
    tag: 'رکورد',
    tagline: 'رابطهٔ تجاری و انطباقی کامل یک آژانس در یک نگاه.',
    business: {
      lead: 'پروفایل، تصویر کامل یک رابطهٔ تجاری است — جایگاه آن، پول آن، و شرایطی که تحت آن فعالیت می‌کند. این همان چیزی است که باز می‌کنید تا بفهمید یا تنظیم کنید یک آژانس مشخص چگونه با پلتفرم تجارت می‌کند.',
      points: [
        { title: 'شرایط اینجا زندگی می‌کنند', desc: 'سطح، وراثت مارک‌آپ و دسترسی به محصولات، اقتصاد این آژانس را تعریف می‌کنند و روی همین رکورد مدیریت می‌شوند.' },
        { title: 'جایگاه در یک نگاه', desc: 'کیف پول، اعتبار و وضعیت KYC فوراً به شما می‌گویند که آیا آژانس همین حالا می‌تواند تجارت کند یا نه.' },
        { title: 'وراثت یا بازنویسی', desc: 'یک آژانس می‌تواند از پیش‌فرض‌های سطح خود پیروی کند، یا بازنویسی‌های سفارشی‌ای را که مخصوص او مذاکره شده حمل کند.' },
      ],
    },
    software: {
      lead: 'یک صفحهٔ جزئیات مخصوص هر آژانس که هویت، پول و پیکربندی را در یک نما گرد می‌آورد.',
      points: [
        { title: 'مدیریت دارایی‌ها و دسترسی', desc: 'SIGNها، کانال‌های فروش، شعبه‌ها، نقش‌ها و دسترسی به محصولات این آژانس از اینجا قابل دسترس هستند.' },
        { title: 'عضویت در گروه‌ها', desc: 'عضویت‌های گروه قیمت‌گذاری آژانس به‌صورت یک نوار برچسبی نمایش داده می‌شود و قواعد محدوده‌بندی‌شده به گروه را تغذیه می‌کند.' },
        { title: 'نمای خودی در برابر مدیر', desc: 'یک آژانس پروفایل خود را عمدتاً فقط‌خواندنی می‌بیند؛ یک مدیر می‌تواند شرایط را ویرایش کند و اقدام انجام دهد.' },
      ],
    },
    related: ['agencies', 'markup', 'branches', 'signs'],
  },

  'contract-templates': {
    title: 'قالب‌های قرارداد',
    tag: 'توافق‌نامه‌ها',
    tagline: 'قالب‌های شرایطی که توافق‌نامهٔ اصلی از آن‌ها تولید می‌شود.',
    business: {
      lead: 'هر آژانس تحت یک توافق‌نامهٔ اصلی تجارت می‌کند. قالب‌های قرارداد، شرایط نسخه‌بندی‌شده‌ای هستند که آن توافق‌نامه‌ها از آن‌ها تولید می‌شوند — تا رابطهٔ حقوقی در سراسر شبکه یکدست، به‌روز و قابل حسابرسی باشد.',
      points: [
        { title: 'یک منبع واحد برای شرایط', desc: 'تولید قرارداد یک آژانس از این فهرست برداشت می‌شود، پس همه شرایط یکسان و به‌روز را امضا می‌کنند.' },
        { title: 'نسخه‌بندی‌شده و قابل حسابرسی', desc: 'نسخه‌های جدید جایگزین نسخه‌های قدیمی می‌شوند؛ نسخه‌های بازنشسته برای تمدید قراردادهای قدیمی‌تر در دسترس می‌مانند.' },
        { title: 'تغذیهٔ چرخهٔ حیات', desc: 'یک قالب، ورودی جریان توافق‌نامهٔ تولید ← ارسال ← امضا ← امضای متقابل ← فعال است.' },
      ],
    },
    software: {
      lead: 'فهرست نسخه‌های قالب که فرم تولید از آن می‌خواند.',
      points: [
        { title: 'افزودن یک نسخه', desc: 'یک نسخهٔ قالب جدید بسازید و سند منبع آن را بارگذاری کنید.' },
        { title: 'بازنشسته کنید، حذف نکنید', desc: 'نسخه‌های جایگزین‌شده را بازنشسته کنید؛ آن‌ها برای قراردادهایی که همچنان روی آن‌ها هستند قابل تفکیک می‌مانند.' },
        { title: 'منبع انتخابگر', desc: 'انتخابگر قالبِ فرمِ تولید قرارداد از این فهرست می‌خواند.' },
      ],
    },
    related: ['agency-onboarding', 'agency-kyc', 'agencies'],
  },

  'reference-data': {
    title: 'داده‌های مرجع',
    tag: 'واژگان اصلی',
    tagline: 'فهرست‌های جست‌وجوی متعارف که هر رزرو، واچر و قیمت از آن‌ها ساخته می‌شود.',
    business: {
      lead: 'داده‌های مرجع، منبع مشترک حقیقت هستند — خطوط هوایی، فرودگاه‌ها، شهرها، ارزها، انواع اتاق، کلاس‌های کابین و ده‌ها مورد دیگر. یک‌بار نرمال‌سازی این‌ها یعنی نتایج جست‌وجو، بلیت‌ها، واچرها و قواعد قیمت‌گذاری همگی در سراسر تأمین‌کنندگان و سرویس‌ها به یک زبان صحبت می‌کنند.',
      points: [
        { title: 'یکدستی در سراسر پلتفرم', desc: 'یک فهرست گلچین‌شده هر سرویس را تغذیه می‌کند، پس کدهای یک تأمین‌کننده همه‌جا به همان مدخل متعارف نگاشت می‌شوند.' },
        { title: 'یک‌بار تغییر، همه‌جا اعمال', desc: 'ویرایش یک ردیف مرجع، آن را برای جست‌وجو، رزرو، اسناد و گزارش‌گیری به‌یک‌باره به‌روز می‌کند.' },
        { title: 'کنترل‌شده، نه متن آزاد', desc: 'واژگان کنترل‌شده داده‌های نامرتب را از قیمت‌گذاری و نگاشت کانال دور نگه می‌دارند.' },
      ],
    },
    software: {
      lead: 'یک صفحهٔ مدیریتی مبتنی بر اسکیما روی حدود ۳۵ دستهٔ مرجع که بر اساس حوزه گروه‌بندی شده‌اند.',
      points: [
        { title: 'مرور و ویرایش بر اساس دسته', desc: 'یک دسته را انتخاب کنید، ردیف‌هایش را جست‌وجو کنید، و مدخل‌ها را افزوده / ویرایش / فعال-غیرفعال کنید؛ برخی دارای تاریخ اثرگذاری هستند (ارزها، مالیات‌ها، نرخ ارز).' },
        { title: 'دسترسی ریزدانه', desc: 'مشاهده / افزودن / ویرایش / وضعیت به‌ازای هر دسته از طریق نقش‌ها و دسترسی اعطا می‌شوند — دکمه‌های اینجا آنچه را نقش شما اجازه می‌دهد بازتاب می‌دهند.' },
        { title: 'متعارف در برابر قابل‌ویرایش', desc: 'چند فهرست (کشورها، منطقه‌های زمانی) متعارف‌اند و به‌صورت متمرکز مدیریت می‌شوند، نه به‌صورت موردی ساخته می‌شوند.' },
      ],
    },
    related: ['rbac', 'data-simulator'],
  },

  'data-simulator': {
    title: 'شبیه‌ساز داده',
    tag: 'داده‌های ساختگی',
    tagline: 'تولید رزروهای واقع‌نما برای به‌کارگیری پلتفرم بدون سفارش‌های واقعی.',
    business: {
      lead: 'شبیه‌ساز، تقاضای باورپذیر می‌سازد — رزروها در میان محصولات، آژانس‌ها و تاریخ‌ها — تا داشبوردها، گزارش‌ها، قیمت‌گذاری و تسویه بتوانند پیش از تجارت واقعی، یا در کنار آن، نمایش داده و آزمون فشار شوند.',
      points: [
        { title: 'اثبات پلتفرم', desc: 'یک سیستم پرشده به ذی‌نفعان نشان می‌دهد گزارش‌گیری و جریان‌های پول در حجم بالا چگونه رفتار می‌کنند.' },
        { title: 'قابل بازگردانی امن', desc: 'سفارش‌های تولیدشده برچسب‌گذاری می‌شوند تا یک دستهٔ کامل بتواند به‌طور تمیز بازگردانده شود.' },
        { title: 'سناریوهای هدفمند', desc: 'یک دسته را به آژانس‌ها یا محصولات مشخصی نشانه بگیرید تا برشی خاص از کسب‌وکار را مدل‌سازی کنید.' },
      ],
    },
    software: {
      lead: 'یک تولیدگر دسته‌ای که سفارش‌های واقعی و برچسب‌گذاری‌شده را به موتور رزرو تزریق می‌کند.',
      points: [
        { title: 'پیکربندی یک دسته', desc: 'حجم، ترکیب محصولات، آژانس‌ها و بازهٔ تاریخی را انتخاب کنید، سپس منتشر کنید.' },
        { title: 'سفارش‌های واقعی، پرچم‌دار', desc: 'اقلام منتشرشده سفارش‌های اصیل سرویس رزرو هستند که «simulated» برچسب خورده‌اند، پس در همهٔ رزروها ظاهر می‌شوند.' },
        { title: 'بازگردانی دستهٔ کامل', desc: 'یک دسته را با یک اقدام حذف کنید تا سیستم به وضعیت قبلی‌اش بازگردد.' },
      ],
    },
    lifecycles: {
      kicker: 'چرخه وضعیت',
      title: 'وضعیت بر اساس محصول',
      successPrefix: 'موفقیت',
      fromLabel: 'از',
      lead: 'هر سفارش روی یک ستون فقرات مشترک حرکت می‌کند — ایجاد، پرداخت، سپس تحقق — اما حالت «تحقق‌یافته» بر اساس آنچه محصول ارائه می‌دهد نام‌گذاری می‌شود. حمل‌ونقل یک سند سفر صادر می‌کند، پس حالت موفقیت آن «بلیت صادرشده» است. هتل‌ها و بیشتر خدمات یک رزرو بدون بلیت را قطعی می‌کنند، پس حالت آن‌ها «تأییدشده» است. ویزا به‌جای صدور بلیت یا تأیید، «تعیین تکلیف» می‌شود، پس حالت موفقیت آن «تأییدشده (صدور)» است. هر سه یک نقطه‌عطف یکسان‌اند: فروش قطعی است و یک سند فروش حسابداری ثبت می‌شود. از آن‌جا یک رزرو می‌تواند لغو و مسترد شود، و مسیرهای ناموفق (شکست پرداخت، انقضای نگه‌داشت، رد توسط اپراتور، رد ویزا) در حالت‌های پایانی خودشان پایان می‌یابند.',
      legend: [
        { label: 'در جریان', kind: 'neutral' },
        { label: 'در انتظار اقدام', kind: 'warn' },
        { label: 'فروش قطعی ← سند صادر می‌شود', kind: 'success' },
        { label: 'مسیر ناموفق / پایانی', kind: 'danger' },
      ],
      items: [
        {
          product: 'پروازها، قطارها و اتوبوس‌ها',
          success: 'بلیت صادرشده',
          lead: 'حمل‌ونقل موجودی را به‌صورت یک PNR نگه می‌دارد، سپس یک بلیت شماره‌دار صادر می‌کند. «بلیت صادرشده» نقطه بی‌بازگشت است — سند صادر شده و فروش ثبت می‌شود.',
          path: [
            { status: 'پیش‌نویس', kind: 'neutral', note: 'سبد ساخته شد' },
            { status: 'نگه‌داشته', kind: 'warn', note: 'PNR یک صندلی را نگه می‌دارد' },
            { status: 'در انتظار پرداخت', kind: 'neutral' },
            { status: 'بلیت صادرشده', kind: 'success', note: 'بلیت الکترونیکی / PNR صادر شد · سند ثبت می‌شود' },
          ],
          branches: [
            { from: 'نگه‌داشته', nodes: [{ status: 'منقضی‌شده', kind: 'danger' }], desc: 'پنجره نگه‌داشت منقضی می‌شود (یک جاروبگر تقریباً هر ۶۰ ثانیه اجرا می‌شود) و صندلی به تأمین‌کننده بازگردانده می‌شود.' },
            { from: 'در انتظار پرداخت', nodes: [{ status: 'ناموفق', kind: 'danger' }], desc: 'پرداخت رد می‌شود یا کرایه تأمین‌کننده هنگام تلاش مجدد منقضی می‌شود — چیزی صادر نمی‌شود.' },
            { from: 'بلیت صادرشده', nodes: [{ status: 'لغوشده', kind: 'danger' }, { status: 'مستردشده', kind: 'neutral' }], desc: 'پس از فروش: یک برآورد لغو اجرا می‌شود، سپس هر پول دریافت‌شده منهای جریمه بازگردانده می‌شود.' },
          ],
        },
        {
          product: 'هتل‌ها',
          success: 'تأییدشده',
          lead: 'یک هتل هرگز بلیت صادر نمی‌کند — یک تأییدیه بازمی‌گرداند، نه یک سند. اقامتگاه‌های آنی با پرداخت تأیید می‌شوند؛ اقامتگاه‌های درخواستی ابتدا کارت را مجاز می‌کنند و منتظر اپراتور (در حال بازبینی) می‌مانند و سپس مبلغ برداشت می‌شود.',
          path: [
            { status: 'پیش‌نویس', kind: 'neutral', note: 'سبد ساخته شد' },
            { status: 'در انتظار پرداخت', kind: 'neutral', note: 'آنی: پرداخت برای تأیید' },
            { status: 'تأییدشده', kind: 'success', note: 'رزرو قطعی شد · سند ثبت می‌شود' },
          ],
          branches: [
            { from: 'در انتظار پرداخت', label: 'درخواستی', nodes: [{ status: 'در حال بازبینی', kind: 'warn', note: 'اپراتور تصمیم می‌گیرد' }, { status: 'تأییدشده', kind: 'success' }], desc: 'کارت مجاز می‌شود، درخواست نزد اپراتور می‌ماند؛ با تأیید، مبلغ برداشت و اقامت تأیید می‌شود.' },
            { from: 'در حال بازبینی', nodes: [{ status: 'ردشده', kind: 'danger' }], desc: 'اپراتور رد می‌کند — مجوز پرداخت باطل می‌شود، پس هیچ مبلغی برداشت نمی‌شود.' },
            { from: 'تأییدشده', nodes: [{ status: 'لغوشده', kind: 'danger' }, { status: 'مستردشده', kind: 'neutral' }], desc: 'لغو پس از فروش طبق قوانین نرخ انجام می‌شود؛ استرداد، پول دریافت‌شده را منهای جریمه بازمی‌گرداند.' },
          ],
        },
        {
          product: 'تورها و سایر خدمات مستقیم (CIP، ترانسفر، سیم‌کارت، بیمه)',
          success: 'تأییدشده',
          lead: 'محصولات خدماتی مستقیم یک سند/تأییدیه صادر می‌کنند، نه بلیت، پس در «تأییدشده» کامل می‌شوند. یک تور یک پرواز + هتل را گرد می‌آورد اما با یک قیمت فروش مستقل از تأمین‌کننده فروخته می‌شود — یک سفارش، یک سند. (CIP، ترانسفر، سیم‌کارت و بیمه مدل‌سازی شده‌اند اما هنوز فعال نیستند.)',
          path: [
            { status: 'پیش‌نویس', kind: 'neutral', note: 'سبد ساخته شد' },
            { status: 'در انتظار پرداخت', kind: 'neutral' },
            { status: 'تأییدشده', kind: 'success', note: 'خدمت قطعی شد · سند ثبت می‌شود' },
          ],
          branches: [
            { from: 'در انتظار پرداخت', nodes: [{ status: 'ناموفق', kind: 'danger' }], desc: 'پرداخت رد می‌شود — خدمت تأیید نمی‌شود.' },
            { from: 'تأییدشده', nodes: [{ status: 'لغوشده', kind: 'danger' }, { status: 'مستردشده', kind: 'neutral' }], desc: 'لغو و استرداد پس از فروش، طبق قوانین لغو محصول.' },
          ],
        },
        {
          product: 'ویزا',
          success: 'تأییدشده (صدور)',
          lead: 'ویزا به‌جای صدور بلیت یا تأیید معمول، تعیین تکلیف می‌شود: درخواست ثبت می‌شود، در حال بررسی می‌ماند و سپس تأیید یا رد می‌شود. «تأییدشده (صدور)» حالت موفقیت ویزاست — همان نقطه‌عطف «فروش قطعی» مانند تأییدشده — و سند فروش را ثبت می‌کند. به سه حالت خلاصه می‌شود: در حال بررسی ← تأیید / رد.',
          path: [
            { status: 'پیش‌نویس', kind: 'neutral', note: 'درخواست ساخته شد' },
            { status: 'در انتظار پرداخت', kind: 'neutral' },
            { status: 'در حال بررسی', kind: 'warn', note: 'در حال پردازش' },
            { status: 'تأییدشده (صدور)', kind: 'success', note: 'ویزا صادر شد · سند ثبت می‌شود' },
          ],
          branches: [
            { from: 'در حال بررسی', nodes: [{ status: 'ردشده', kind: 'danger' }], desc: 'درخواست رد می‌شود — سندی ثبت نمی‌شود. شکست پرداخت یا لغو ویزا نیز به «ردشده» می‌رسد.' },
          ],
        },
      ],
    },
    related: ['reference-data', 'rbac'],
  },

  rbac: {
    title: 'نقش‌ها و دسترسی',
    tag: 'RBAC',
    tagline: 'ترکیب مجوزهای ریزدانه در نقش‌هایی که افراد شما حمل می‌کنند.',
    business: {
      lead: 'دسترسی با مجوزها اداره می‌شود، نه با عناوین شغلی. نقش‌ها و دسترسی جایی است که کدهای مجوز اتمی را در نقش‌ها گرد می‌آورید و آن‌ها را اعطا می‌کنید — تا هر فرد دقیقاً بتواند آنچه را باید انجام دهد و نه بیشتر، چه کارکنان پلتفرم باشند چه کاربر یک آژانس.',
      points: [
        { title: 'کمترین امتیاز', desc: 'اعطای مجوزهای محدود، شعاع آسیب را در صورت سوءاستفاده از یک حساب محدود می‌کند.' },
        { title: 'دو محدوده', desc: 'نقش‌های پلتفرم در سراسر شبکه عمل می‌کنند؛ نقش‌های آژانس به مستأجر خودشان محدود می‌شوند.' },
        { title: 'ایمن در برابر قفل‌شدگی', desc: 'نقش‌های سیستمی مهروموم‌شده (مثلاً مدیر پلتفرم) مجوزهایشان را قفل نگه می‌دارند تا هیچ‌کس نتواند دسترسی خودش را حذف کند.' },
      ],
    },
    software: {
      lead: 'نقش‌ها، کاربران و یک فهرست زندهٔ مجوزها در یک‌جا.',
      points: [
        { title: 'ساختن یک نقش', desc: 'کدهای مجوز گروه‌بندی‌شده بر اساس ماژول را تیک بزنید؛ یک نقش فقط همان مجموعه‌ای است که انتخاب می‌کنید.' },
        { title: 'ماتریس داده‌های مرجع', desc: 'مجوزهای داده‌های مرجع به‌ازای دسته × اقدام (مشاهده/افزودن/ویرایش/وضعیت) اعطا می‌شوند؛ نقش‌های آژانس فقط مشاهده می‌گیرند.' },
        { title: 'تخصیص به کاربران', desc: 'زبانهٔ کاربران نقش‌ها را به افراد وصل می‌کند، محدود به پلتفرم یا یک آژانس مشخص.' },
      ],
    },
    related: ['users', 'reference-data', 'settings'],
  },

  users: {
    title: 'کاربران',
    tag: 'حساب‌ها',
    tagline: 'افرادی که می‌توانند وارد شوند، و نقش‌هایی که حمل می‌کنند.',
    business: {
      lead: 'کاربران، افرادی هستند که پلتفرم را می‌گردانند — کارکنان پلتفرم و کارکنان آژانس. مدیریت آن‌ها اینجا همان راهی است که کنترل می‌کنید چه کسی دسترسی دارد، آن را با ورود و خروج افراد به‌روز نگه می‌دارید، و هر اقدام را به یک حساب پاسخ‌گو گره می‌زنید.',
      points: [
        { title: 'دسترسی از استخدام پیروی می‌کند', desc: 'ایجاد و غیرفعال‌سازی به‌موقع حساب‌ها، خط مقدم امنیت است.' },
        { title: 'قدرت در نقش‌هاست', desc: 'یک کاربر به‌تنهایی کاری نمی‌کند — نقش‌هایش تصمیم می‌گیرند چه می‌تواند بکند.' },
        { title: 'پاسخ‌گویی', desc: 'اقدامات به یک حساب نام‌دار قابل انتساب‌اند، که برای حسابرسی و اختلافات اهمیت دارد.' },
      ],
    },
    software: {
      lead: 'فهرست حساب‌ها همراه با نقش‌ها و وضعیت‌شان.',
      points: [
        { title: 'ایجاد و تخصیص', desc: 'یک کاربر بسازید و یک یا چند نقش به او تخصیص دهید، محدود به پلتفرم یا یک آژانس.' },
        { title: 'فعال / غیرفعال کردن', desc: 'دسترسی را هنگام خروج فرد بدون حذف تاریخچه غیرفعال کنید.' },
        { title: 'آگاه به محدوده', desc: 'مدیران همهٔ کاربران را مدیریت می‌کنند؛ یک مدیر آژانس فقط افراد خودش را مدیریت می‌کند.' },
      ],
    },
    related: ['rbac', 'settings'],
  },

  settings: {
    title: 'تنظیمات',
    tag: 'پیکربندی',
    tagline: 'پیکربندی در سطح پلتفرم و آژانس در یک‌جا.',
    business: {
      lead: 'تنظیمات، اهرم‌هایی را نگه می‌دارند که شکل ظاهر و رفتار پلتفرم را می‌سازند — برندینگ، اعلان‌ها، یکپارچه‌سازی‌ها و پیکربندی پیش‌فرض. درست‌کردن آن‌ها تجربه را یکدست و لوله‌کشی زیرساخت را متصل نگه می‌دارد.',
      points: [
        { title: 'هویت و تجربه', desc: 'برندینگ و پیش‌فرض‌ها تعیین می‌کنند کنسول برای کاربران شما چگونه به نظر می‌رسد و رفتار می‌کند.' },
        { title: 'متصل بمانید', desc: 'تنظیمات یکپارچه‌سازی و اعلان، پلتفرم را در گفت‌وگو با دنیای بیرون نگه می‌دارند.' },
        { title: 'مالکیت محدوده‌بندی‌شده', desc: 'مدیران پلتفرم تنظیمات سراسر پلتفرم را مدیریت می‌کنند؛ مدیران آژانس محدودهٔ خودشان را مدیریت می‌کنند.' },
      ],
    },
    software: {
      lead: 'پنل‌های پیکربندی گروه‌بندی‌شده برای برندینگ، اعلان‌ها، یکپارچه‌سازی‌ها و پیش‌فرض‌های آژانس.',
      points: [
        { title: 'ویرایش بر اساس بخش', desc: 'پنل‌های گروه‌بندی‌شده را طی کنید و حوزه‌هایی را که مدیریت می‌کنید ذخیره کنید.' },
        { title: 'محدود به مجوز', desc: 'دسترسی نیازمند مجوز مدیریت تنظیمات است؛ مدخل نوار کناری با بقیهٔ بخش سیستم یکدست می‌ماند.' },
        { title: 'پلتفرم در برابر آژانس', desc: 'آنچه می‌توانید تغییر دهید بستگی دارد به اینکه محدودهٔ پلتفرم را دارید یا آژانس را.' },
      ],
    },
    related: ['rbac', 'users'],
  },

  issues: {
    title: 'ردیاب مشکلات',
    tag: 'تضمین کیفیت داخلی',
    tagline: 'ردیاب داخلی نقص‌ها برای گزارش و تفکیک مشکلات محصول.',
    business: {
      lead: 'ردیاب مشکلات همان راهی است که مشکلات یافت‌شده در کنسول ثبت، تفکیک و رفع می‌شوند — یک حلقهٔ بازخورد مهندسی خصوصی، جدا از تیکت‌های پشتیبانی مشتری، تا کیفیت بدون رسیدن سروصدا به آژانس‌ها بهبود یابد.',
      points: [
        { title: 'بستن حلقه', desc: 'یک گزارش ساختارمند همراه با زمینه، «خراب است» را به چیزی تبدیل می‌کند که یک مهندس بتواند رویش اقدام کند.' },
        { title: 'پشتیبانی مشتری نیست', desc: 'این تضمین کیفیت داخلی است — متمایز از تیکت‌های پشتیبانی رو به آژانس.' },
        { title: 'شواهد پیوست‌شده', desc: 'اسکرین‌شات‌ها و زمینهٔ محیط، مشکلات را قابل بازتولید می‌کنند.' },
      ],
    },
    software: {
      lead: 'یک صف تفکیک از مشکلات گزارش‌شده همراه با اسنپ‌شات‌ها و وضعیت.',
      points: [
        { title: 'گزارش از هر جا', desc: 'یک مشکل را (همراه با اسنپ‌شات) از هر جا از طریق میان‌بر گزارش‌دهنده ثبت کنید، سپس آن را اینجا دنبال کنید.' },
        { title: 'تفکیک و وضعیت', desc: 'روی صف کار کنید — مشکلات را تخصیص، اولویت‌بندی و در چرخهٔ حیات‌شان جابه‌جا کنید.' },
        { title: 'محدود به توسعه‌دهنده', desc: 'تفکیک کامل به نقش توسعه‌دهنده محدود است، تا ردیاب نمای هر مدیری را شلوغ نکند.' },
      ],
    },
    related: ['my-issues'],
  },

  'my-issues': {
    title: 'مشکلات گزارش‌شدهٔ من',
    tag: 'گزارش‌های من',
    tagline: 'مشکلاتی که شخصاً مطرح کرده‌اید، و جایگاه هر کدام.',
    business: {
      lead: 'این برش خودتان از ردیاب مشکلات است — گزارش‌هایی که ثبت کرده‌اید و پیشرفت‌شان. این حلقهٔ بازخورد را برای گزارش‌دهنده می‌بندد: می‌توانید ببینید آنچه مطرح کردید دیده شده و در حال حرکت است.',
      points: [
        { title: 'دیده‌شدن برای گزارش‌دهندگان', desc: 'دانستن اینکه یک گزارش دریافت شده و در حال پیشرفت است، افراد را به ادامهٔ پرچم‌زدن مشکلات تشویق می‌کند.' },
        { title: 'زمینهٔ شما', desc: 'فقط مشکلاتی که خودتان مطرح کردید، پس فهرست شخصاً مرتبط می‌ماند.' },
        { title: 'دنبال‌کردن تا حل', desc: 'هر گزارش را از باز تا حل‌شده دنبال کنید.' },
      ],
    },
    software: {
      lead: 'یک نمای فیلترشده از ردیاب مشکلات، محدود به گزارش‌های خودتان.',
      points: [
        { title: 'دیدن گزارش‌هایتان', desc: 'هر مشکلی که ثبت کردید، همراه با وضعیت فعلی‌اش.' },
        { title: 'باز کردن برای جزئیات', desc: 'وارد یک گزارش شوید تا رشتهٔ گفت‌وگو، اسنپ‌شات و به‌روزرسانی‌هایش را ببینید.' },
        { title: 'مطرح‌کردن بیشتر', desc: 'مشکلات جدید را از میان‌بر گزارش‌دهنده ثبت کنید؛ آن‌ها اینجا ظاهر می‌شوند.' },
      ],
    },
    related: ['issues'],
  },

  'supply-properties': {
    title: 'اقامتگاه‌های هتلی',
    tag: 'موجودی خودی',
    tagline: 'فهرست هتل‌هایی که مستقیماً قرارداد کرده‌اید — اتاق‌هایی که خودتان مالک و فروشنده‌شان هستید.',
    business: {
      lead: 'این‌ها هتل‌هایی هستند که مستقیماً قرارداد می‌کنید، در مقابل نرخ‌هایی که از موتورهای هتلی بیرونی بازفروشی می‌کنید. چون موجودی از آنِ شماست، اتاق‌ها، نرخ‌های شبانه و ظرفیت را خودتان تعیین می‌کنید — و کل حاشیهٔ سود را نگه می‌دارید نه سهم یک بدبانک را.',
      points: [
        { title: 'موجودی خودی در برابر بازفروشی', desc: 'اقامتگاه‌های خودی در جست‌وجو و رزرو در کنار نتایج موتور هتلی بیرونی می‌نشینند؛ اینجا قیمت و ظرفیت را از ابتدا تا انتها کنترل می‌کنید.' },
        { title: 'محدوده، دامنه را تعیین می‌کند', desc: 'یک اقامتگاه با محدودهٔ پلتفرم به موجودی مشترک تبدیل می‌شود که هر آژانسی می‌تواند بفروشد؛ یک مورد با محدودهٔ آژانس خصوصی همان آژانس می‌ماند.' },
        { title: 'حالت فروش در یک نگاه', desc: 'هر اقامتگاه یا آنی است (فوراً تأیید می‌شود) یا بنا به درخواست (رزروی که اپراتور تأیید می‌کند) — کارت مشخص می‌کند کدام است.' },
      ],
    },
    software: {
      lead: 'یک شبکهٔ قابل جست‌وجو و فیلتر از اقامتگاه‌های شما همراه با وضعیت سریع.',
      points: [
        { title: 'یافتن یک اقامتگاه', desc: 'بر اساس نام یا شهر جست‌وجو کنید و بر اساس محدوده، حالت فروش یا وضعیت فیلتر کنید.' },
        { title: 'راه‌اندازی یک مورد جدید', desc: 'از صفر بسازید، یا از یک هتل مرجع دانه‌گذاری کنید، از طریق کشوی راه‌اندازی.' },
        { title: 'باز کردن برای مدیریت', desc: 'روی رکورد اقامتگاه کلیک کنید تا اتاق‌ها، نرخ‌ها، سهمیه، خدمات جانبی و قراردادش را مدیریت کنید.' },
      ],
    },
    related: ['supply-property-detail', 'reference-data'],
  },

  'supply-property-detail': {
    title: 'اقامتگاه هتلی',
    tag: 'رکورد اقامتگاه',
    tagline: 'رکورد کامل یک اقامتگاه — اتاق‌ها، نرخ‌ها، ظرفیت، افزودنی‌ها و قراردادی که پشت آن است.',
    business: {
      lead: 'یک اقامتگاه هتلی، تکه‌ای از موجودی است که مالک و فروشندهٔ مستقیم آن هستید. هر چیزی که یک رزرو نیاز دارد اینجا زندگی می‌کند: چه اتاق‌هایی وجود دارند، هر شب چقدر هزینه دارند، چند تا در دسترس‌اند، چه افزودنی‌هایی می‌شود اضافه کرد، و قراردادی که آن را اداره می‌کند. این را درست کنید و اقامتگاه هم در کنسول B2B شما و هم در B2C آمادهٔ فروش است.',
      points: [
        { title: 'موجودی خودی، حاشیهٔ سود شما', desc: 'یک قرارداد مستقیم که خودتان بارگذاری می‌کنید هیچ مارک‌آپ بدبانکی ندارد — فاصلهٔ میان قیمت خالص و فروش کاملاً از آنِ شماست.' },
        { title: 'محدودهٔ پلتفرم در برابر آژانس', desc: 'محدودهٔ پلتفرم اقامتگاه را به‌عنوان موجودی مشترک برای آژانس‌ها منتشر می‌کند؛ محدودهٔ آژانس آن را خصوصی نگه می‌دارد. ردیف‌های متعلق به پلتفرم برای یک آژانس فقط‌خواندنی‌اند.' },
        { title: 'آنی در برابر بنا به درخواست', desc: 'آنی فوراً در برابر سهمیه تأیید می‌شود؛ بنا به درخواست، رزرو را به‌عنوان درخواستی ثبت می‌کند که اپراتور در بازهٔ SLA آن را تأیید یا رد می‌کند (پرداخت مجاز می‌شود، و هنگام تأیید کسر می‌شود).' },
        { title: 'ظرفیت از شما محافظت می‌کند', desc: 'سهمیه، تعداد اتاق قراردادی است؛ نگه‌داری‌ها و اتاق‌های فروخته‌شده کسر می‌شوند تا یک فروش آنی هرگز نتواند بیش‌فروشی کند.' },
      ],
    },
    software: {
      lead: 'یک فضای کاری زبانه‌دار برای یک اقامتگاه — هر زبانه بخشی از رکورد است، با نشانی که میزان محتوایش را نشان می‌دهد. در ادامه آمده که هر زبانه چه می‌کند و اقلامش چگونه کار می‌کنند.',
      points: [
        { title: 'نمای کلی', desc: 'خلاصهٔ ابتدا-خواندنی: موقعیت و نقشه، رتبهٔ ستاره، زنجیره، امکانات شاخص، توضیحات، و شاخص‌های کلیدی زنده — اشغال ماه‌تاکنون، ADR و RevPAR (همگی در برابر کل موجودی اتاق اقامتگاه محاسبه می‌شوند).' },
        { title: 'اتاق‌ها و انواع اتاق', desc: 'هر نوع اتاق را افزوده / ویرایش کنید: یک دستهٔ استانداردشده از مرجع انواع اتاق انتخاب کنید (این همان چیزی است که تطبیق جست‌وجو و نگاشت کانال را می‌راند)، یک نام نمایشی رو به مهمان و کد کوتاه، بیشینهٔ اشغال، اندازه به متر مربع، و کل موجودی فیزیکی — آخری همان مقسوم‌علیه پشت اشغال / RevPAR در نمای کلی است.' },
        { title: 'تخت‌ها (به‌ازای نوع اتاق)', desc: 'چیدمان تخت یک ترکیب‌گر است، نه متن آزاد: ردیف‌هایی از تعداد × نوع تخت برگرفته از مرجع انواع تخت (مثلاً «۱ کینگ + ۱ تخت مبلی»). رشتهٔ ترکیب‌شده همان چیزی است که در نتایج جست‌وجو و روی واچر نشان داده می‌شود، پس همه‌جا یکدست می‌ماند.' },
        { title: 'امکانات (به‌ازای اتاق و اقامتگاه)', desc: 'یک چندگزینه‌ای مبتنی بر مرجع که بر اساس دستهٔ امکانات گروه‌بندی شده (در داده‌های مرجع ← امکانات مدیریت می‌شود). به‌جای تایپ متن آزاد از فهرست کنترل‌شده انتخاب کنید؛ انتخاب‌ها به‌صورت برچسب‌های نمایشی ذخیره می‌شوند تا در کنسول B2B، روی واچر و در B2C یکسان رندر شوند.' },
        { title: 'گالری', desc: 'عکس‌های سطح اقامتگاه و اتاق را بارگذاری و مرتب کنید. این‌ها تصاویری هستند که کارگزاران در جست‌وجو و رزرو و مهمانان روی واچر می‌بینند؛ اتاقی بدون عکس به گالری اقامتگاه بازمی‌گردد.' },
        { title: 'طرح‌های نرخ', desc: 'یک طرح نرخ یک بستهٔ قابل فروش است — فقط اتاق، B&B، غیرقابل‌استرداد و غیره. هر کدام قیمت‌های خودش را حمل می‌کند و می‌تواند حالت فروش اقامتگاه (آنی / بنا به درخواست) را بازنویسی کند. تقویم و قیمت‌های جست‌وجو همیشه به‌ازای طرح نرخ هستند.' },
        { title: 'نرخ‌ها و تقویم', desc: 'به‌ازای هر طرح نرخ، قیمت خالص یک شب، یک بازهٔ تاریخی، یا یک فصل کامل را در یک اقدام تعیین کنید. تاریخ‌های آخر هفته و فصل نشانه‌های بصری دارند (یک قرص رنگی)، و توقف‌فروش یک تاریخ را بدون حذف قیمتش می‌بندد. برای ذخیره، مقدار نرخ الزامی است — یک مجموعهٔ خالی رد می‌شود.' },
        { title: 'سهمیه و نگه‌داری‌ها', desc: 'تعداد قراردادی اتاق‌های در دسترس در هر روز. شبکه هر روز را به نگه‌داشته (رزروشده، پرداخت هنوز کسر نشده) در برابر فروخته‌شده (تأییدشده) در برابر آزاد برای فروش می‌شکند؛ یک تعداد را در سراسر یک بازهٔ تاریخی به‌صورت انبوه به‌روز کنید. فروش‌های آنی آن را در زمان واقعی کاهش می‌دهند؛ فروش‌های بنا به درخواست تا وقتی اپراتور تأیید نکند به آن دست نمی‌زنند.' },
        { title: 'خدمات جانبی', desc: 'افزودنی‌هایی که این اقامتگاه می‌فروشد — ترانسفر فرودگاه، صبحانه، اسپا، تحویل دیرهنگام اتاق — هر کدام از مرجع انواع خدمات جانبی با یک قیمت و یک مبنای شارژ (به‌ازای رزرو / به‌ازای شب / به‌ازای مسافر) برداشت می‌شوند. آن‌ها به‌عنوان افزودنی در هزینه‌های یک رزرو ظاهر می‌شوند.' },
        { title: 'رزروهای زنده', desc: 'هر رزروی که در برابر این اقامتگاه انجام شده. برای اقامت‌های بنا به درخواست، نوار تأیید / رد اینجاست: تأیید، پرداخت مجازشده را کسر می‌کند و سهمیه را متعهد می‌کند؛ رد، مجوز را باطل می‌کند — هر دو در پنجرهٔ SLA اقامتگاه.' },
        { title: 'قرارداد و تنظیمات', desc: 'قرارداد تأمین‌کننده به‌علاوهٔ کلیدهای عملیاتی: حالت فروش (آنی، یا بنا به درخواست با ساعت‌های SLA و روزهای مهلت رزرو)، محدودهٔ پلتفرم در برابر آژانس، و وضعیت فعال اقامتگاه.' },
        { title: 'راه‌اندازی، ویرایش و ابزارهای انبوه', desc: 'یک کشوی راه‌اندازی هدایت‌شده یک اقامتگاه را از صفر یا دانه‌گذاری‌شده از یک هتل مرجع می‌سازد؛ کشوی ویرایش بعداً جزئیات اصلی را تنظیم می‌کند؛ و کشوهای انبوه نرخ‌ها یا سهمیه را در چند روز به‌یک‌باره تعیین می‌کنند.' },
      ],
    },
    modes: {
      lead: 'دو کلید رفتار یک اقامتگاه را تغییر می‌دهند — حالت فروش (زیر قرارداد و تنظیمات تعیین می‌شود، قابل بازنویسی به‌ازای طرح نرخ) و محدوده (هنگام ساخت اقامتگاه تعیین می‌شود).',
      modes: [
        { name: 'Instant', when: 'سهمیهٔ زنده‌ای که به آن اعتماد دارید', desc: 'رزرو فوراً تأیید می‌شود و سهمیه را کاهش می‌دهد؛ پرداخت بی‌درنگ کسر می‌شود. وقتی هیچ اتاقی برای تاریخ‌ها و اشغال آزاد نباشد مسدود می‌شود.' },
        { name: 'On-Request', when: 'هتل باید تأیید کند', desc: 'رزرو به‌عنوان درخواست گرفته می‌شود — پرداخت مجاز می‌شود (کسر نمی‌شود) و سهمیه دست‌نخورده می‌ماند — و اپراتور در بازهٔ SLA آن را تأیید یا رد می‌کند. تأیید، پرداخت را کسر و سهمیه را متعهد می‌کند؛ رد، مجوز را باطل می‌کند.' },
        { name: 'محدودهٔ پلتفرم', when: 'موجودی مشترک', desc: 'اقامتگاه به‌عنوان موجودی قابل فروش برای آژانس‌ها منتشر می‌شود؛ آن‌ها آن را فقط‌خواندنی می‌بینند و تحت مارک‌آپ خرده‌فروشی خودشان بازفروشی می‌کنند.' },
        { name: 'محدودهٔ آژانس', when: 'موجودی خصوصی', desc: 'اقامتگاه به یک آژانس واحد تعلق دارد و فقط توسط همان قابل فروش است.' },
      ],
    },
    examples: [
      {
        title: 'ظرفیت در یک شب (حالت فروش آنی)',
        rows: [
          { label: 'سهمیهٔ قراردادی', value: '10' },
          { label: '− نگه‌داشته (در انتظار کسر)', value: '3', accent: 'info' },
          { label: '− فروخته‌شده (تأییدشده)', value: '5' },
          { label: 'آزاد برای فروش', value: '2', strong: true, accent: 'accent' },
        ],
        note: 'رزروهای بنا به درخواست تا وقتی اپراتور تأیید نکند سهمیه مصرف نمی‌کنند — آن‌ها بر اساس نوع اتاق مقید می‌شوند، نه تعداد روزانه.',
      },
      {
        title: 'نرخ‌ها و تقویم — یک اقامت ۳ شبه (دلوکس · B&B)',
        rows: [
          { label: 'پنج‌شنبه ۲ آوریل · خالص روز کاری', value: '2,200,000' },
          { label: 'جمعه ۳ آوریل · خالص آخر هفته', value: '2,600,000', accent: 'info' },
          { label: 'شنبه ۴ آوریل · خالص آخر هفته', value: '2,600,000', accent: 'info' },
          { label: 'جمع جزئی اتاق (۳ شب)', value: '7,400,000', strong: true },
        ],
        note: 'هر شب قیمت خالص تعیین‌شده برای طرح نرخش را حمل می‌کند؛ نشانه‌های آخر هفته/فصل کمک‌های بصری‌اند — قیمت همان چیزی است که برای آن تاریخ تعیین می‌کنید. یک شب توقف‌فروش صرف‌نظر از قیمت غیرقابل رزرو خواهد بود.',
      },
      {
        title: 'خدمات جانبی روی آن رزرو (۲ مهمان، ۳ شب)',
        rows: [
          { label: 'جمع جزئی اتاق', value: '7,400,000' },
          { label: '+ صبحانه · به‌ازای مسافر / شب · ۱۵۰٬۰۰۰ × ۲ × ۳', value: '+900,000', accent: 'success' },
          { label: '+ ترانسفر فرودگاه · به‌ازای رزرو', value: '+1,200,000', accent: 'success' },
          { label: 'جمع کل اقامتگاه (پیش از مارک‌آپ)', value: '9,500,000', strong: true, accent: 'accent' },
        ],
        note: 'مبنای شارژ هر خدمت جانبی (به‌ازای رزرو / به‌ازای شب / به‌ازای مسافر) تعیین می‌کند چگونه ضرب شود. سپس مارک‌آپ خرده‌فروشی از مارک‌آپ و قواعد روی آن اعمال می‌شود تا به قیمت مسافر برسد.',
      },
    ],
    tabs: {
      overview: {
        title: 'نمای کلی',
        lead: 'خلاصهٔ ابتدا-خواندنی اقامتگاه — کجاست، چه ارائه می‌دهد، و همین حالا چگونه عمل می‌کند.',
        points: [
          { title: 'هویت و موقعیت', desc: 'نام، رتبهٔ ستاره، زنجیره، نشانی و پین نقشه — واقعیت‌هایی که یک رزروکننده اول بررسی می‌کند.' },
          { title: 'امکانات شاخص و توضیحات', desc: 'نقاط فروش اقامتگاه، برگرفته از امکانات مبتنی بر مرجع و توضیحات متن آزاد.' },
          { title: 'شاخص‌های کلیدی زنده', desc: 'اشغال ماه‌تاکنون، ADR (متوسط نرخ روزانه) و RevPAR (درآمد به‌ازای اتاق در دسترس) — همگی در برابر کل موجودی اتاق اقامتگاه محاسبه می‌شوند، پس فقط وقتی درست خوانده می‌شوند که هر نوع اتاق تعداد موجودی‌اش تعیین شده باشد.' },
        ],
        examples: [
          {
            title: 'شاخص‌های کلیدی چگونه محاسبه می‌شوند — ۴۰ اتاق، یک ماه ۳۰ روزه',
            rows: [
              { label: 'اتاق-شب‌های در دسترس (۴۰ × ۳۰)', value: '1,200' },
              { label: 'اتاق-شب‌های فروخته‌شده', value: '900' },
              { label: 'اشغال ماه‌تاکنون (۹۰۰ ÷ ۱٬۲۰۰)', value: '75%', accent: 'info', strong: true },
              { label: 'درآمد اتاق', value: '90,000,000' },
              { label: 'ADR (درآمد ÷ ۹۰۰ فروخته‌شده)', value: '100,000' },
              { label: 'RevPAR (درآمد ÷ ۱٬۲۰۰ در دسترس)', value: '75,000', accent: 'success', strong: true },
            ],
            note: 'RevPAR قیمت و اشغال را ترکیب می‌کند، پس اگر یکی از نرخ یا نرخ پرشدن افت کند، پایین می‌آید. نبودِ تعداد موجودی یک نوع اتاق، مقسوم‌علیه را می‌شکند — کاشی‌ها تا وقتی در زبانهٔ اتاق‌ها تعیین شود یک خط‌تیره نشان می‌دهند.',
          },
        ],
      },
      rooms: {
        title: 'اتاق‌ها و انواع اتاق',
        lead: 'تعریف آنچه اقامتگاه می‌تواند بفروشد: هر نوع اتاق، چگونه می‌خواباند، و چه مقدار از آن وجود دارد.',
        points: [
          { title: 'دستهٔ نرمال‌شده', desc: 'یک نوع استانداردشده از مرجع انواع اتاق انتخاب کنید — این همان چیزی است که تطبیق جست‌وجو و نگاشت کانال را می‌راند، نه نام متن آزاد.' },
          { title: 'نام نمایشی و کد', desc: 'یک نام رو به مهمان («دلوکس رو به دریا») و یک کد کوتاه برای اپراتور.' },
          { title: 'تخت‌ها — یک ترکیب‌گر، نه متن آزاد', desc: 'چیدمان تخت را از ردیف‌های تعداد × نوع تخت (مثلاً «۱ کینگ + ۱ تخت مبلی») برگرفته از مرجع انواع تخت بسازید؛ رشتهٔ ترکیب‌شده همان چیزی است که در جست‌وجو و روی واچر نشان داده می‌شود.' },
          { title: 'امکانات', desc: 'یک چندگزینه‌ای مبتنی بر مرجع که بر اساس دسته گروه‌بندی شده — به‌صورت برچسب‌های نمایشی ذخیره می‌شود تا در B2B، روی واچر و در B2C یکسان رندر شوند.' },
          { title: 'کل موجودی', desc: 'تعداد فیزیکی اتاق از این نوع — مقسوم‌علیه پشت اشغال و RevPAR در نمای کلی، پس باید تعیین شود تا شاخص‌های کلیدی درست خوانده شوند.' },
        ],
      },
      gallery: {
        title: 'گالری',
        lead: 'عکس‌هایی که کارگزاران در جست‌وجو و رزرو و مهمانان روی واچر می‌بینند.',
        points: [
          { title: 'عکس‌های اقامتگاه و اتاق', desc: 'در سطح اقامتگاه و به‌ازای نوع اتاق بارگذاری کنید؛ آن‌ها را طوری مرتب کنید که قوی‌ترین تصویر پیشتاز باشد.' },
          { title: 'بازگشت منطقی', desc: 'نوع اتاقی بدون عکس مخصوص خودش به گالری اقامتگاه بازمی‌گردد، پس یک آگهی هرگز بدون تصویر نیست.' },
        ],
      },
      rates: {
        title: 'نرخ‌ها و تقویم',
        lead: 'قیمت خالص هر طرح نرخ را، یک شب یا یک فصل کامل در هر بار، تعیین کنید.',
        points: [
          { title: 'یک طرح نرخ یک بسته است', desc: 'فقط اتاق، B&B، غیرقابل‌استرداد… هر کدام قیمت‌های خودش را حمل می‌کند و می‌تواند حالت فروش اقامتگاه را بازنویسی کند. قیمت‌های جست‌وجو همیشه به‌ازای طرح نرخ هستند.' },
          { title: 'یک روز · بازه · فصل', desc: 'یک شب، یک بازهٔ تاریخی، یا یک فصل کامل را در یک اقدام قیمت‌گذاری کنید. تاریخ‌های آخر هفته و فصل یک قرص رنگی حمل می‌کنند تا الگو دیده شود.' },
          { title: 'توقف‌فروش، حذف نکنید', desc: 'بستن یک تاریخ با توقف‌فروش قیمتش را برای بعد نگه می‌دارد — برای ذخیره مقدار نرخ الزامی است، پس یک مجموعهٔ خالی رد می‌شود.' },
        ],
        examples: [
          {
            title: 'از نرخ خالص تا قیمتی که یک شریک می‌بیند',
            rows: [
              { label: 'نرخ خالص که برای شب بارگذاری می‌کنید', value: '1,200,000' },
              { label: '+ مارک‌آپ خرده‌فروشی ۸٪ (مارک‌آپ و قواعد)', value: '+96,000', accent: 'success' },
              { label: 'قیمت جست‌وجو / فروش', value: '1,296,000', strong: true },
            ],
            note: 'خالص را اینجا تعیین می‌کنید؛ قیمت فروش، خالص به‌علاوهٔ هر چیزی است که لایهٔ قیمت‌گذاری Retail اضافه می‌کند. آن فاصله، حاشیهٔ سود شما روی موجودی خودی است.',
          },
        ],
      },
      allotment: {
        title: 'سهمیه و نگه‌داری‌ها',
        lead: 'تعداد قراردادی اتاق‌های در دسترس در هر روز، و اینکه هر کدام چگونه تخصیص یافته است.',
        points: [
          { title: 'چهار حالت در هر روز', desc: 'سهمیه، تعداد قراردادی است؛ هر روز به نگه‌داشته (رزروشده، پرداخت هنوز کسر نشده)، فروخته‌شده (تأییدشده) و آزاد برای فروش شکسته می‌شود.' },
          { title: 'تنظیم انبوه', desc: 'یک تعداد سهمیه را در سراسر یک بازهٔ تاریخی در یک اقدام تعیین کنید، به همان روشی که نرخ‌ها تعیین می‌شوند.' },
          { title: 'آنی در برابر بنا به درخواست', desc: 'فروش‌های آنی آزاد برای فروش را در زمان واقعی کاهش می‌دهند تا هرگز نتوانید بیش‌فروشی کنید؛ فروش‌های بنا به درخواست تا وقتی اپراتور تأیید نکند به سهمیه دست نمی‌زنند.' },
          { title: 'خواندن جدول تخصیص موجودی', desc: 'هر ردیف یک نوع اتاق است — با انتخاب یک ردیف، تقویمِ پایین برای همان اتاق نمایش داده می‌شود. اکنون دسترس‌پذیری در جست‌وجو، تقویم روزبه‌روز (نرخ + آزاد برای فروش + توقف فروش)، «سقف قطعی/روز» اتاق، «پیش‌فرض توقف فروش» و حداقل اقامتِ نرخ را رعایت می‌کند — به‌همراه مهلت رزرو «بنا به درخواست» اقامتگاه. «آزادسازی خودکار» و «رزرو گروهی» ذخیره می‌شوند اما هنوز اعمال نمی‌شوند.' },
          { title: 'ستون · نوع اتاق', desc: 'اینکه این تنظیمات برای کدام اتاق اعمال می‌شود. با کلیک روی ردیف (یا چک‌باکس آن) همان اتاق در تقویمِ پایین نمایش داده می‌شود.' },
          { title: 'ستون · کل موجودی', desc: '«تعداد کل واحدهای» این نوع اتاق — شمار اتاق‌های فیزیکی از این نوع. اینجا فقط‌خواندنی است: بازتابی از مقداری است که در زبانهٔ «اتاق‌ها و انواع اتاق» تنظیم می‌کنید (برای تغییر، اتاق را ویرایش کنید) و تا وقتی تنظیم نشود «—» نشان داده می‌شود. توسط تقویم تعیین نمی‌شود؛ از آن به‌عنوان مرجعی برای تعیین اندازهٔ سهمیهٔ روزانه استفاده کنید.' },
          { title: 'ستون · سقف قطعی / روز', desc: 'سقفی مطلق برای تعداد اتاق‌های قابل‌فروشِ این نوع در هر روز — یک حد ایمنی بالاتر از سهمیهٔ تقویم. در جست‌وجوی دسترس‌پذیری اعمال می‌شود: آزادِ فروشِ هر روز تا این مقدار محدود می‌گردد. خالی = بدون سقف.' },
          { title: 'ستون · آزادسازی خودکار پس از', desc: 'زمان برنامه‌ریزی‌شده برای آزادسازی سهمیهٔ فروخته‌نشده پیش از ورود (۷۲ ساعت، ۷، ۱۴ یا ۳۰ روز؛ «هرگز» آن را تا زمان خروج نگه می‌دارد). قابل‌ویرایش و ذخیره می‌شود؛ اما آزادسازی خودکار هنوز پیاده‌سازی نشده است.' },
          { title: 'ستون · رزرو گروهی', desc: 'بیشینهٔ برنامه‌ریزی‌شدهٔ اتاق‌های این نوع که هم‌زمان می‌توان برای رزروهای گروهی نگه داشت. قابل‌ویرایش و ذخیره می‌شود؛ اما اعمال آن هنوز انجام نشده است. خالی = بدون سقف اختصاصیِ گروه.' },
          { title: 'ستون · توقف فروش', desc: 'پیش‌فرضِ سطح اتاق: وقتی روشن باشد، روزهایی که ردیف تخصیص صریح ندارند در جست‌وجوی دسترس‌پذیری بسته در نظر گرفته می‌شوند. توقف فروشِ روزانه روی تقویم همیشه برای همان تاریخ بر آن اولویت دارد.' },
        ],
        examples: [
          {
            title: 'ظرفیت یک روز واحد',
            rows: [
              { label: 'سهمیهٔ قراردادی', value: '20' },
              { label: '− نگه‌داشته (در انتظار کسر)', value: '−3' },
              { label: '− فروخته‌شده (تأییدشده)', value: '−5' },
              { label: 'آزاد برای فروش', value: '12', accent: 'success', strong: true },
            ],
            note: 'یک رزرو آنی فوراً یک اتاق را از آزاد ← فروخته‌شده جابه‌جا می‌کند؛ یک رزرو بنا به درخواست تا وقتی اپراتور آن را در زبانهٔ رزروهای زنده تأیید کند، هر چهار عدد را دست‌نخورده می‌گذارد.',
          },
        ],
      },
      ancillaries: {
        title: 'خدمات جانبی',
        lead: 'افزودنی‌هایی که این اقامتگاه در کنار اتاق می‌فروشد — ترانسفرها، صبحانه، اسپا، تحویل دیرهنگام اتاق.',
        points: [
          { title: 'از مرجع', desc: 'دستهٔ هر افزودنی از مرجع انواع خدمات جانبی می‌آید؛ شما یک قیمت و یک مبنای شارژ تعیین می‌کنید.' },
          { title: 'مبنای شارژ ضرب می‌کند', desc: 'به‌ازای رزرو (یک‌بار)، به‌ازای شب (× شب‌ها)، یا به‌ازای مسافر (× مهمانان) — مبنا تعیین می‌کند قیمت روی یک رزرو چگونه مقیاس بگیرد.' },
          { title: 'ظهور در هزینه‌ها', desc: 'افزودنی‌های اضافه‌شده در زبانهٔ هزینه‌های رزرو ظاهر می‌شوند و در قیمت مسافر جمع می‌شوند.' },
        ],
        examples: [
          {
            title: 'افزودنی‌ها روی یک اقامت ۳ شبه، ۲ مهمان',
            rows: [
              { label: 'ترانسفر فرودگاه · ۴۵۰٬۰۰۰ به‌ازای رزرو', value: '450,000' },
              { label: 'صبحانه · ۲۵۰٬۰۰۰ به‌ازای شب × ۳', value: '750,000' },
              { label: 'جمع کل افزودنی‌های اضافه‌شده به رزرو', value: '1,200,000', accent: 'accent', strong: true },
            ],
            note: 'مبنای شارژ همان چیزی است که باعث می‌شود همان قیمت فهرست به‌شکل متفاوت مقیاس بگیرد — به‌ازای رزرو یک‌بار شارژ می‌شود، به‌ازای شب طول اقامت را دنبال می‌کند، و به‌ازای مسافر تعداد نفرات را دنبال می‌کند.',
          },
        ],
      },
      bookings: {
        title: 'رزروهای زنده',
        lead: 'هر رزروی که در برابر این اقامتگاه انجام شده — و جایی که اقامت‌های بنا به درخواست تأیید می‌شوند.',
        points: [
          { title: 'فهرست کامل رزروها', desc: 'ببینید چه کسی رزرو کرده، کدام اتاق و طرح نرخ، تاریخ‌ها و وضعیت.' },
          { title: 'تأیید / رد بنا به درخواست', desc: 'برای اقامت‌های بنا به درخواست نوار تصمیم اینجاست: تأیید، پرداخت مجازشده را کسر می‌کند و سهمیه را متعهد می‌کند؛ رد، مجوز را باطل می‌کند.' },
          { title: 'درون SLA', desc: 'هر دو اقدام باید در پنجرهٔ SLA بنا به درخواست اقامتگاه (زیر قرارداد و تنظیمات تعیین‌شده) رخ دهند، وگرنه درخواست منقضی می‌شود.' },
        ],
      },
      settings: {
        title: 'قرارداد و تنظیمات',
        lead: 'قرارداد تأمین‌کننده به‌علاوهٔ کلیدهای عملیاتی که اداره می‌کنند اقامتگاه چگونه بفروشد.',
        points: [
          { title: 'شرایط قرارداد', desc: 'توافق تجاری پشت اقامتگاه — مبنای نرخ‌های خالصی که بارگذاری می‌کنید.' },
          { title: 'حالت فروش', desc: 'آنی، یا بنا به درخواست با ساعت‌های SLA و روزهای مهلت رزرو. طرح‌های نرخ می‌توانند این را به‌ازای هر طرح بازنویسی کنند.' },
          { title: 'محدوده و وضعیت', desc: 'پلتفرم (مشترک با آژانس‌ها، فقط‌خواندنی برای آن‌ها) در برابر آژانس (خصوصی)، به‌علاوهٔ وضعیت فعال / متوقف‌شدهٔ اقامتگاه.' },
        ],
      },
    },
    related: ['supply-properties', 'reference-data', 'markup'],
  },
};
